import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const cameraDeleteAtom = createMutationAtomFactory(
  'settings.cameraDelete',
  (params: { id: string }) => ({
    iotCameraDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
